import APIClient from "../../../common/APIClient";

import { displayError } from "../commonActions";
import { formatDate } from "../../../common/Utilities";
import qs from "qs";

const GET_MISSING_ENTRIES = "GET_MISSING_ENTRIES";
const GET_MISSING_ENTRIES_BY_USER = "GET_MISSING_ENTRIES_BY_USER";
const GET_MISSING_ENTRIES_BY_EMPLOYEE = "GET_MISSING_ENTRIES_BY_EMPLOYEE";
const REFRESH_REPORTS = "REFRESH_REPORTS";
const GET_WEEKLY_REPORTS = "GET_WEEKLY_REPORTS";
const GET_TIMESHEET_CUMULATIVE_REPORT = "GET_TIMESHEET_CUMULATIVE_REPORT";
const RESET_TIMESHEET_CUMULATIVE_REPORT = "RESET_TIMESHEET_CUMULATIVE_REPORT";
const GET_PRODUCTIVITY_REPORTS = "GET_PRODUCTIVITY_REPORTS";
const GET_ACCOMPLISHMENT_REPORTS = "GET_ACCOMPLISHMENT_REPORTS";
const APPROVED = "Approved";

export const FTE_DIVISOR = 21.75;

const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
};

export const refreshReports = () => {
  return (dispatch) => {
    dispatch({ type: REFRESH_REPORTS });
  };
};

export const getMissingEntries = (query) => {
  return (dispatch) => {
    query.start_date = formatDate(new Date(query.start_date), "-");
    query.end_date = formatDate(new Date(query.end_date), "-");

    return client()
      .get("projects/missing-entries", { params: query })
      .then((result) => {
        const json = result.data;
        if (json) {
          let missingEntries = json.data;
          if (missingEntries.length === 0) {
            missingEntries = null;
          }
          dispatch({ type: GET_MISSING_ENTRIES, missingEntries });
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const getMissingEntriesByUser = (query) => {
  return (dispatch) => {
    query.start_date = formatDate(new Date(query.start_date), "-");
    query.end_date = formatDate(new Date(query.end_date), "-");

    return client()
      .get("projects/missing-entries-by-user", { params: query })
      .then((result) => {
        const json = result.data;
        if (json) {
          let missingEntriesByUser = json.data;
          if (missingEntriesByUser.length === 0) {
            missingEntriesByUser = null;
          }
          dispatch({ type: GET_MISSING_ENTRIES_BY_USER, missingEntriesByUser });
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const getMissingEntriesByEmployee = (query) => {
  return (dispatch) => {
    query.start_date = formatDate(new Date(query.start_date), "-");
    query.end_date = formatDate(new Date(query.end_date), "-");

    return client()
      .get("projects/missing-entries-by-employee", { params: query })
      .then((result) => {
        const json = result.data;
        if (json) {
          let missingEntriesByEmployee = json.data;
          if (missingEntriesByEmployee.length === 0) {
            missingEntriesByEmployee = null;
          }
          dispatch({
            type: GET_MISSING_ENTRIES_BY_EMPLOYEE,
            missingEntriesByEmployee,
          });
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const getWeeklyMonthlyReport = (query) => {
  return (dispatch) => {
    query.start_date = formatDate(new Date(query.start_date), "-");
    query.end_date = formatDate(new Date(query.end_date), "-");

    return client()
      .get("reports/weekly-monthly-report", {
        params: query,
        paramsSerializer: (params) => {
          return qs.stringify(params);
        },
      })
      .then((result) => {
        const json = result.data;
        if (json) {
          const weeklyReport = json.data;
          if (weeklyReport) {
            dispatch({ type: GET_WEEKLY_REPORTS, weeklyReport });
          }
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};
export const getAccomplishmentReport = (query) => {
  return (dispatch) => {
    query.start_date = formatDate(new Date(query.start_date), "-");
    query.end_date = formatDate(new Date(query.end_date), "-");

    return client()
      .get("reports/accomplishment-report-list", {
        params: query,
        paramsSerializer: (params) => {
          return qs.stringify(params);
        },
      })
      .then((result) => {
        const json = result.data;
        if (json) {
          const accomplishmentReport = json.data;
          if (accomplishmentReport) {
            dispatch({
              type: GET_ACCOMPLISHMENT_REPORTS,
              accomplishmentReport,
            });
          }
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};
export const getProductivityReport = (query) => {
  return (dispatch) => {
    query.start_date = formatDate(new Date(query.start_date), "-");
    query.end_date = formatDate(new Date(query.end_date), "-");

    return client()
      .get("reports/filter-list", {
        params: query,
        paramsSerializer: (params) => {
          return qs.stringify(params);
        },
      })
      .then((result) => {
        const json = result.data;
        if (json) {
          const productivityReport = json.data;
          if (productivityReport) {
            dispatch({ type: GET_PRODUCTIVITY_REPORTS, productivityReport });
          }
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const getProjCumulativeReport = (projectIds) => {
  return (dispatch, getState) => {
    const projectCumulative = getState().reports.projectCumulative;
    if (projectCumulative === null) {
      client()
        .get("reports/cumulative-report", {
          params: {
            project_ids: projectIds,
          },
          paramsSerializer: (params) => {
            return qs.stringify(params);
          },
        })
        .then((json) => {
          const result = json.data;
          if (result) {
            const projectCumulative = result.data;
            if (projectCumulative) {
              dispatch({
                type: GET_TIMESHEET_CUMULATIVE_REPORT,
                projectCumulative,
              });
            }
            return projectCumulative;
          }
        })
        .catch((error) => {
          dispatch(displayError(error));
        });
    }
  };
};

export const resetProjectCumulative = () => {
  return (dispatch) => {
    dispatch({ type: RESET_TIMESHEET_CUMULATIVE_REPORT });
  };
};

/**
 * This function merge the revenue details of projects
 * that are connected
 */

export const mergeBudgetRevenueDetails = (projects) => {
  let totalRevenue = 0;
  let totalFullyLoadedCost = 0;
  let totalUnloadedCost = 0;
  let totalExternalCost = 0;
  let totalMandays = 0;

  if (!projects.length) {
    return null;
  }

  projects.forEach((project) => {
    totalRevenue += project.project_revenue;
    totalExternalCost += project.project_external_cost;
    totalMandays += project.mandays;

    if (project.fully_loaded) {
      totalFullyLoadedCost += project.fully_loaded_cost;
    } else {
      totalUnloadedCost += project.fully_loaded_cost;
    }
  });

  return {
    totalMandays,
    totalRevenue,
    totalFullyLoadedCost,
    totalUnloadedCost,
    totalExternalCost,
  };
};

/**
 * This function merge the actual time entries of projects that
 * are connected
 */
export const mergeActualRevenueDetails = (projects, timeEntries) => {
  let totalMandays = 0;
  let totalRevenue = 0;
  let totalFullyLoadedCost = 0;
  let totalUnloadedCost = 0;
  let totalExternalCost = 0;
  let arrProjectIds = [];

  if (projects.length) {
    projects.forEach((project) => {
      totalRevenue += project.project_revenue;
      totalExternalCost += project.project_external_cost;
    });

    arrProjectIds = projects.map((project) => project.id);
  }

  let totalActualHours = 0;

  timeEntries.length &&
    timeEntries
      .filter((data) => {
        if (
          arrProjectIds.includes(data.project_id) &&
          data.timesheet_details.status === APPROVED
        ) {
          return data;
        }
        return false;
      })
      .forEach((timeEntry) => {
        let requestorDetails = {};

        let costingYear;
        let isFullyLoaded;

        const duration = +timeEntry.duration;

        totalActualHours += +duration;
        //get the details of the tagged project in the time entry
        projects
          .filter((data) => {
            if (data.id === timeEntry.project_id) {
              return data;
            }
            return false;
          })
          .forEach((project) => {
            costingYear = project.costing_year;
            if (project.fully_loaded) {
              isFullyLoaded = 1;
            } else {
              isFullyLoaded = 0;
            }
          });

        if (typeof timeEntry.timesheet_details !== "undefined") {
          const timesheetDetails = timeEntry.timesheet_details;

          if (
            timesheetDetails &&
            typeof timesheetDetails.requestor_details !== "undefined"
          ) {
            requestorDetails = timesheetDetails.requestor_details;
          }
        }

        let cost = 0;
        let bandCostByHours = 0;

        //get the band cost
        if (Object.keys(requestorDetails).length) {
          const bandCosts = requestorDetails.band_cost;

          bandCosts.length &&
            bandCosts
              .filter((data) => {
                if (
                  data.year === costingYear &&
                  data.fully_loaded === isFullyLoaded
                ) {
                  return data;
                }
                return false;
              })
              .forEach((bandCost) => {
                cost = bandCost.cost;
              });

          //compute the actual band cost
          // bandCostByHours = (timeEntry.duration / 8) * cost;
          bandCostByHours = timeEntry.duration * cost;
          if (isFullyLoaded) {
            totalFullyLoadedCost += parseFloat(bandCostByHours.toFixed(2));
          } else {
            totalUnloadedCost += parseFloat(bandCostByHours.toFixed(2));
          }
        }
      });

  totalMandays = totalActualHours / 8;

  return {
    totalMandays,
    totalRevenue,
    totalFullyLoadedCost,
    totalUnloadedCost,
    totalExternalCost,
  };
};

export const generateExportData = (exportHeaders, exportData) => {
  let data = [exportHeaders];

  exportData.forEach((dataRow) => {
    let row = [];

    Object.keys(dataRow).forEach((key) => {
      row.push(dataRow[key]);
    });

    data.push(row);
  });

  return data;
};
